import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=5f0b1e28&scoped=true&"
import script from "./DeviceDetail.vue?vue&type=script&lang=js&"
export * from "./DeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetail.vue?vue&type=style&index=0&id=5f0b1e28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b1e28",
  null
  
)

export default component.exports